// extracted by mini-css-extract-plugin
export default {"content_wrapper":"touch-block_content_wrapper__S2HNQ","funcs_wrapper":"touch-block_funcs_wrapper__VnBA5","func":"touch-block_func__5ffHv"};